import React from 'react';
import type {List} from 'immutable';

import {Anchor, Dialogue, Button, Text} from '@albert-io/atomic';

interface Props extends PropsWithClassNameRequired {
  handleClose: () => void;
  nullEmailStudents: List<any>;
}

const SchoolEmailDomainNotFound = ({className, handleClose, nullEmailStudents}: Props) => {
  const nullEmailNamesArray = nullEmailStudents
    .map((item) => item.get('fields').get('name'))
    .toJS();
  return (
    <Dialogue hideCloseBtn className={className} size='m' title='An error occurred'>
      <Dialogue.Body>
        <div className='flex flex-col'>
          <Text className='mb-x3'>
            Your roster includes students that do not have emails. We cannot import these students
            until your administrator provides us with a valid school email domain to use for account
            provisioning (e.g. academy.org). Please have them reach out to our customer support team
            for guidance. The affected accounts include:{' '}
            {nullEmailNamesArray.map(
              (item, index) => `${item}${index + 1 < nullEmailNamesArray.length ? ', ' : ''}`
            )}
            . Learn more about school email{' '}
            <Anchor
              href='https://help.albert.io/en/articles/3847312-what-are-school-managed-email-domains'
              target='_blank'
            >
              domains
            </Anchor>
            .
          </Text>
        </div>
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button onClick={() => handleClose()}>Dismiss</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

export default SchoolEmailDomainNotFound;
